import { ActionTypes } from './action-types.enum';

const initialState = {
  categories: {},
  lastUsedCategoryId: '',
};

const renameCategory = (state, action) => {
  const { categories } = state;

  if (action.payload?.data?.groupId && action.payload.data?.id) {
    const categoryIndex = categories[action.payload.data.groupId]
      .findIndex((el) => el.id === action.payload.data.id);

    if (categoryIndex >= 0) {
      const category = categories[action.payload.data.groupId][categoryIndex];
      categories[action.payload.data.groupId][categoryIndex] = {
        ...category,
        title: action.payload?.data.title,
      };
    }
  }

  return {
    ...state,
    categories: { ...categories },
  };
};

const deleteCategory = (state, action) => {
  const { categories } = state;

  if (action.payload?.groupId && action.payload.id) {
    const groupCategories = categories[action.payload.groupId];
    if (groupCategories) {
      return {
        ...state,
        categories: {
          ...state.categories,
          [action.payload.groupId]: groupCategories
            .filter((el) => el.id !== action.payload?.id),
        },
      };
    }
  }

  return {
    ...state,
    categories,
  };
};

const addCategory = (state, action) => {
  const { categories } = state;

  if (action.payload?.data?.groupId && action.payload.data.id && action.payload.data.title) {
    categories[action.payload.data.groupId]
      .unshift({ id: action.payload.data.id, title: action.payload.data.title });
  }

  return {
    ...state,
    categories,
  };
};

const addCategories = (state, action) => {
  const { categories } = state;

  if (action.payload?.groupId) {
    categories[action.payload.groupId] = action.payload.categories;
    if (!state.lastUsedCategoryId) {
      return {
        ...state,
        categories,
        lastUsedCategoryId: categories[action.payload.groupId]?.[0]?.id
      };
    }
  }

  return {
    ...state,
    categories,
  };
};

const updateCategoryCount = (state, action) => {
  const { categories, lastUsedCategoryId } = state;

  if (action.payload?.groupId) {
    const categoryIndex = categories[action.payload.groupId]
      .findIndex((el) => el.id === lastUsedCategoryId);

    if (categoryIndex >= 0) {
      const category = categories[action.payload.groupId][categoryIndex];
      switch (action.payload.type) {
        case 'decrease':
          categories[action.payload.groupId][categoryIndex] = {
            ...category,
            count: category.count ? category.count - action.payload.count : category.count,
          };
          break;
        case 'increase':
          categories[action.payload.groupId][categoryIndex] = {
            ...category,
            count: (category.count !== undefined && category.count !== null)
            && (action.payload.count && action.payload.count > 0)
              ? category.count + action.payload.count : category.count,
          };
          break;
        case 'manually':
          categories[action.payload.groupId][categoryIndex] = {
            ...category,
            count: (category.count !== undefined && category.count !== null)
            && (action.payload.count && action.payload.count > 0)
              ? category.count - action.payload.previousCount + Number(action.payload.count)
              : category.count,
          };
          break;
      }
    }

    return {
      ...state,
      categories: {...categories},
    };
  }
};

const setLastUsedCategory = (state, action) => {
  return {
    ...state,
    lastUsedCategoryId: action.payload?.categoryId ?? state.lastUsedCategoryId,
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.ADD_CATEGORIES:
      return addCategories(state, action);
    case ActionTypes.DELETE_CATEGORY:
      return deleteCategory(state, action);
    case ActionTypes.ADD_CATEGORY:
      return addCategory(state, action);
    case ActionTypes.RENAME_CATEGORY:
      return renameCategory(state, action);
    case ActionTypes.SET_LAST_USED_CATEGORY:
      return setLastUsedCategory(state, action);
    case ActionTypes.UPDATE_CATEGORY_COUNT:
      return updateCategoryCount(state, action);
    default:
      return state;
  }
};
